import React, {useEffect, useRef, useState} from 'react';
import Section from "../../components/section";
import HelperService from "../../services/helper-service";
import MainLayout from "../../layouts/main";
import {useGlobalNotificationMessage} from "../../context/message";
import PageTitle from "../../components/page-title";
import DataTableActions from "../../components/datatable/data-table-actions";
import DataTableBase from "../../components/datatable/data-table-base";
import {useAttachmentCategoryService} from "../../services/attachment-category-service";
import AddEditAttachmentCategoryModal from "./add-edit-attachment-category-modal";
import {AppRoutes, AttachmentCategoryTypes, BuildingOwnershipTypes} from "../../utils/constants";
import {Tab, Tabs} from "react-bootstrap";
import {useParams, useNavigate} from "react-router-dom";


export default function AttachmentCategoriesList () {
  let attachmentCategoryService = useAttachmentCategoryService();
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [tabKey, setTabKey] = useState('user');
  const addEditModal = useRef();

  const navigate = useNavigate();
  let { tab } = useParams();

  useEffect(()=>{
    if (tab){
      setTabKey(tab);
    } else {
      setTabKey('user');
    }
    attachmentCategoryService.getList()
      .then((rows)=>{
        setRows(rows);
        setLoaded(true);
      })
      .catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa získať dáta.");
      })
  }, [tab]);

  const onAddEditAction = (row=null, e=null)=>{
    let defaultType = null;
    if (tabKey && ['user', 'membership', 'membershipGallery'].includes(tabKey)){
      defaultType = AttachmentCategoryTypes[tabKey].val;
    }
    addEditModal.current.openModal(row, defaultType);
  };

  const onAddEditCallbackAction = (item=null)=>{
    setRows(HelperService.addOrReplaceItemInList(rows,item));
  };

  const onDelAction = (item, e=null)=>{
    if (true===confirm('Naozaj odstrániť záznam?')){
      attachmentCategoryService.delModel(item.id)
        .then(()=>{
          setRows(HelperService.removeItemFromList(rows,item));
        })
        .catch(error => {
          HelperService.handleApiErrors(error, addErrorMessage);
        })
    }
  };

  const columns = [{
    name: 'Názov',
    selector: row => row.title,
    sortable: true,
  },{
    name: 'Cesta',
    selector: row => row.path,
    sortable: true,
  },{
    name: 'Skupina',
    center: true,
    selector: row => row.type,
    format: row => <span className={`badge bg-${HelperService.getObjByKey(Object.values(AttachmentCategoryTypes), 'val', row.type)?.color}`}>{HelperService.getObjByKey(Object.values(AttachmentCategoryTypes), 'val', row.type)?.title}</span>,
    filterSelector: row => { return HelperService.getObjByKey(Object.values(AttachmentCategoryTypes), 'val', row.type)?.title },
    sortable: true,
  },{
    cell: row => <DataTableActions row={row} actions={[
      {title: 'Upraviť', icon: <span className="mdi mdi-book-edit-outline"></span>, action: onAddEditAction, className: 'hover-text-primary'},
      {title: 'Zmazať', icon: <span className="mdi mdi-trash-can-outline"></span>, action: onDelAction, className: 'hover-text-danger'},
    ]} />,
    right: true,
    allowOverflow: true,
    button: false,
  }];

  return (
    <>
      <AddEditAttachmentCategoryModal ref={addEditModal} onSuccess={onAddEditCallbackAction} />

      <Section animation={HelperService.getRandomAnimation()}>
        <div className="container mt-4">

          <PageTitle>Kategórie dokumentov</PageTitle>

          <button className="btn btn-primary mb-2" onClick={(e)=>onAddEditAction(null, e)}><span className="mdi mdi-plus"></span> Pridať</button>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">

                  <Tabs
                    variant="pills"
                    defaultActiveKey="user"
                    activeKey={tabKey}
                    onSelect={(k) => {
                      navigate(AppRoutes.attachmentCategories.path+'/'+k);
                      //setTabKey(k);
                    }}
                    className="mb-3"
                  >
                    <Tab eventKey="user" title={AttachmentCategoryTypes.user.title}>
                      <DataTableBase
                        progressPending={!loaded}
                        columns={columns}
                        data={rows.filter((r)=> r.type===AttachmentCategoryTypes.user.val)}
                        // onRowClicked={(row)=>navigate(`${AppRoutes.users.path}/${row.id}`)}
                      />
                    </Tab>
                    <Tab eventKey="membership" title={AttachmentCategoryTypes.membership.title}>
                      <DataTableBase
                        progressPending={!loaded}
                        columns={columns}
                        data={rows.filter((r)=> r.type===AttachmentCategoryTypes.membership.val)}
                        // onRowClicked={(row)=>navigate(`${AppRoutes.users.path}/${row.id}`)}
                      />
                    </Tab>
                    <Tab eventKey="membershipGallery" title={AttachmentCategoryTypes.membershipGallery.title}>
                      <DataTableBase
                        progressPending={!loaded}
                        columns={columns}
                        data={rows.filter((r)=> r.type===AttachmentCategoryTypes.membershipGallery.val)}
                        // onRowClicked={(row)=>navigate(`${AppRoutes.users.path}/${row.id}`)}
                      />
                    </Tab>
                  </Tabs>

                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}

AttachmentCategoriesList.getLayout = function getLayout(page) {
  return (
    <MainLayout>
      {page}
    </MainLayout>
  )
}

AttachmentCategoriesList.getSEO = function getSEO() {
  return {
    title: "Kategórie dokumentov",
  }
}
